import { useState, useEffect } from "react";
import { getProfile } from "@/api/profile.api";
import type { Profile } from "@/types/profile.types";

export function useProfile() {
  const [profile, setProfile] = useState<Profile | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setIsLoading(true);
    getProfile()
      .then(setProfile)
      .catch((e) => setError(e as Error))
      .finally(() => setIsLoading(false));
  }, []);

  return { profile, isLoading, error };
}
